import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import { QUERY_KEYS_SIH, useChartsData } from '../../../../Common/hooks/useChartsData';


export const ServicesChartsDataContext = createContext();

const ServicesChartsDataProvider = ({ children , module }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_SIH.PERMANENCE_DAYS_HOSPITALIZATION,
            url: 'governanceroom/dashboard/sihsus/aih/hospitalizationPermanence'
        },
        {
            location: filters.unidade.value,
            year: filters.ano?.value,
            month: filters.competencia?.value,
            city: filters.cidade?.value
        }
    );

    const chartData = data
        ? {
              counterServices: [
                  {
                      total_permanences: data.counterServices[0] ? data.counterServices[0].total_permanences : 0,
                      average_permanences: data.counterServices[0] ? data.counterServices[0].average_permanences : 0
                  }
              ],
              counterYear : data.counterYear ? data.counterYear : [],
              selectedYear : data.selectedYear ? data.selectedYear : []
          }
        : {
                counterServices: [
                    {
                        total_permanences: 0,
                        average_permanences: 0
                    }
                ],
                counterYear: [],
                selectedYear: []
          };

    const colors = ['#1F77B4', '#FF7F0E'];

    const subtitles = ["Média de dias de Permanência"];

    return (
        <ServicesChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                module,
                colors,
                subtitles,
                data
            }}
        >
            {children}
        </ServicesChartsDataContext.Provider>
    );
};

export default ServicesChartsDataProvider;
